<template>
  <transition
    enter-active-class="transition-opacity duration-150 ease-out"
    enter-class="opacity-0"
    leave-active-class="transition-opacity duration-150 ease-out"
    leave-to-class="opacity-0"
  >
    <div
      v-if="active"
      class="flex items-center justify-center overflow-hidden inset-0"
      :class="isFullPage ? 'fixed z-[999]' : 'absolute z-[29]'"
    >
      <div class="absolute inset-0 bg-white/50" @click="cancel" />
      <div
        class="relative rounded-full border-4 border-gray-300 border-t-transparent border-r-transparent animate-spin"
        :class="isFullPage ? 'w-20 h-20' : 'w-12 h-12'"
      />
    </div>
  </transition>
</template>

<script>
export default {
  props: {
    active: {
      type: Boolean,
      required: true,
    },
    canCancel: {
      type: Boolean,
      default: false,
    },
    isFullPage: {
      type: Boolean,
      default: false,
    },
  },
  watch: {
    active: {
      immediate: true,
      handler(val) {
        if (process.server) {
          return;
        }
        if (val && this.canCancel) {
          document.addEventListener("keyup", this.keyupListener);
        } else {
          document.removeEventListener("keyup", this.keyupListener);
        }
      },
    },
  },
  beforeDestroy() {
    if (process.client) {
      document.removeEventListener("keyup", this.keyupListener);
    }
  },
  methods: {
    keyupListener(evt) {
      if (evt?.key === "Escape") {
        this.cancel();
      }
    },
    cancel() {
      if (!this.canCancel || !this.active) {
        return;
      }
      this.$emit("close");
      this.$emit("update:active", false);
    },
  },
};
</script>
